import Header from '@components/Bundling/Header'
import MainItemWrapper from '@components/Bundling/MainItemWrapper'
import OuterWrapper from '@components/Bundling/OuterWrapper'
import RelatedItemsSidebarWrapper from '@components/Bundling/RelatedItemsSidebarWrapper'
import RelatedItemsWrapper from '@components/Bundling/RelatedItemsWrapper'

const exports = {
  Header,
  OuterWrapper,
  MainItemWrapper,
  RelatedItemsWrapper,
  RelatedItemsSidebarWrapper,
}

export default exports
